export default __webpack_public_path__ + "static/media/pawprint.491ac7d0.png";